import { CostDashboardResponse } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchCosts = async (query, signal) => {
    const params = new URLSearchParams();
    if (query.from !== undefined)
        params.set('from', query.from);
    if (query.to !== undefined)
        params.set('to', query.to);
    const suffix = params.toString() === '' ? '' : `?${params.toString()}`;
    return CostDashboardResponse.parse(await request(`/api/v1/communication/costs${suffix}`, { signal })).snapshots;
};
//# sourceMappingURL=communication-costs.js.map